/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { useContext, useEffect, useMemo } from 'react';
import { CoreContext } from '../../context/CoreContext';
import ModalAlert from './Alert';
import ModalSelectProfile from './SelectProfile';
import { getScaledValue } from '../../ui/styled';

interface ModalState {
  type?: string;
  title?: string;
  text?: string;
  action?: { title?: string; action?: () => void };
  icon?: Record<string, unknown>;
  closeable?: boolean;
}

export default function ModalCore({ setFocus }: { setFocus?: (key: string) => void }) {
  const { modal } = useContext(CoreContext);
  const modalState = (modal ?? {}) as ModalState;

  const defaultContent = useMemo(() => {
    return modalState?.type === 'alert'
      ? modalState
      : ({
          closeable: true,
          title: 'Sem Conexão!',
          text: 'Algo errado com a sua conexão de internet.',
          action: {
            action: undefined,
            title: 'Tentar novamente',
          },
          icon: {
            icon: 'face',
            width: getScaledValue(40),
            height: getScaledValue(40),
            fill: '#fff',
          },
        } as ModalState);
  }, [modalState]);

  return (
    <>
      <ModalSelectProfile setFocus={setFocus} opened={modalState?.type === 'select-profile'} />
      <ModalAlert {...defaultContent} setFocus={setFocus} opened={modalState?.type === 'alert'} />
    </>
  );
}
